<div class='container'>
  <div class='row'
    style="text-align: center; padding-top: 20px !important; font-family: 'Roboto', sans-serif; font-weight: normal; font-size: 100%;">
    <div class='col-12-md form-container'>
      <div class="form-group">
        <label for="codiceFiscale">Codice Fiscale</label>
        <input type="text" [(ngModel)]="codiceFiscale" class="form-control" />
      </div>
      <div class="form-group">
        <label for="password">Password</label>
        <input type="password" [(ngModel)]="password" class="form-control" />
      </div>
      <div class="form-group">
        <label for="passwordConferma">Conferma Password</label>
        <input type="password" [(ngModel)]="passwordConferma" class="form-control" />
      </div>
      <div class="form-group">
        <label for="code">Codice inviato per email</label>
        <input type="text" [formControl]="code" class="form-control" />
        <!-- Messaggio per caratteri non validi -->
        @if (code?.hasError('invalidCharacters') && code?.touched) {
          <div>
            <small style="color: red;">Sono ammessi solo i caratteri A-Z e i numeri da 1 a 9.</small>
          </div>
        }

        <!-- Messaggio per lunghezza non valida -->
        @if (code?.hasError('invalidLength') && code?.touched) {
          <div>
            <small style="color: red;">
              La stringa deve essere lunga esattamente 6 caratteri. Lunghezza attuale:
              {{ code?.errors?.invalidLength.actualLength }}.
            </small>
          </div>
        }
      </div>
      <div class="form-group">
        <button class="btn btn-primary" (click)="onSubmitNuovaPassword()" [disabled]="code.invalid">Aggiorna
        Password</button>
      </div>
    </div>
  </div>
</div>